module.exports = {"540522100":"吉雄镇","540522101":"岗堆镇","540522102":"甲竹林镇","540522103":"江塘镇","540522104":"杰德秀镇","540522200":"朗杰学乡","540522201":"昌果乡","540522202":"东拉乡","540522203":"克西乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540522.json
// module id = 2529
// module chunks = 0